import React from "react";
import { getCurrentCulture } from "@utils";

export default function WorldCupLinkIFrame() {
	const currentCulture = getCurrentCulture();
	const link = `${WEBPACK_WORLD_CUP_LINK}${
		currentCulture === "sq"
			? "sqi"
			: currentCulture === "sv"
				? "se"
				: currentCulture
	}`;

	return (
		<iframe
			id="world-cup-link-frame"
			className="popup--full__iframe"
			src={link}
		></iframe>
	);
}
